import React from 'react';
import classnames from 'classnames';
import enhanceWithClickOutside from 'react-click-outside';
import { isBrowser } from 'react-device-detect';

import Options from 'components/atoms/Options';
import Triangle from 'components/atoms/Triangle';

import styles from './index.css';

class Select extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			optionsOpen: false,
		};
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.toggleSelectBox = this.toggleSelectBox.bind(this);
	}

	onSelect(option) {
		this.setState({ optionsOpen: false });
		this.props.onSelect(option);
	}

	handleClickOutside() {
		this.setState({ optionsOpen: false });
	}

	toggleSelectBox() {
		if (!this.props.disabled) {
			this.setState({ optionsOpen: !this.state.optionsOpen });
		}
	}

	render() {
		const {
			className,
			options,
			placeholder = 'select...',
			PlaceholderIcon,
			selected = {
				id: -1,
				label: '',
				value: '',
			},
			disabled,
			selectBoxConfig: selectBoxConfigProp,
			optionConfig: optionConfigProp,
			moreWeight,
		} = this.props;

		const selectBoxConfig = {
			class: styles.defaultSelectBox,
			activeClass: styles.activeSelectBox,
			triangle: true,
			triangleDown: false,
			triangleSize: 10,
			triangleColor: '#2D2926',
			triangleBorderWidth: 1,
			animation: false,
			...selectBoxConfigProp,
		};

		const optionConfig = { border: true, ...optionConfigProp };

		const { optionsOpen } = this.state;

		return (
			<div
				className={classnames(styles.select, className, {
					[styles.disabled]: disabled,
				})}
			>
				<div
					className={classnames(styles.selectBox, selectBoxConfig.class, {
						[styles.active]: optionsOpen,
						[selectBoxConfig.activeClass]: optionsOpen,
						[styles.animation]: selectBoxConfig.animation,
						[styles.isBrowser]: isBrowser,
					})}
					role="button"
					tabIndex="0"
					onClick={this.toggleSelectBox}
					onKeyPress={() => {}}
				>
					<div className={styles.mask} />
					<div className={styles.container}>
						{selected.id === -1 ? (
							<div className={styles.placeholder}>
								{PlaceholderIcon && (
									<div className={styles.icon}>
										<PlaceholderIcon />
									</div>
								)}
								<div className={styles.text}>{placeholder}</div>
							</div>
						) : (
							selected.label
						)}
						{selectBoxConfig.triangle && (
							<Triangle
								direction={selectBoxConfig.triangleDown || optionsOpen ? 'down' : 'right'}
								className={styles.triangle}
								size={selectBoxConfig.triangleSize}
								color={selectBoxConfig.triangleColor}
								borderWidth={selectBoxConfig.triangleBorderWidth}
							/>
						)}
					</div>
				</div>
				<div
					className={classnames(styles.options)}
					style={{ height: optionsOpen ? `${options.length * 60}px` : 0 }}
				>
					<Options
						options={options}
						selected={selected}
						onSelect={this.onSelect}
						moreWeight={moreWeight}
						{...optionConfig}
					/>
				</div>
			</div>
		);
	}
}

export default enhanceWithClickOutside(Select);



// WEBPACK FOOTER //
// ./src/components/atoms/Select/index.js